import { APP_INITIALIZER } from '@angular/core';
import { CustomMatIconService } from './custom-mat-icon.service';

export function iconsFactory(mi: CustomMatIconService): any {
  return (): any => mi.initCustomMatIcons();
}

export const CustomMatIconInitializer = {
  provide: APP_INITIALIZER,
  useFactory: iconsFactory,
  deps: [CustomMatIconService],
  multi: true,
};
